import type { UIMatch } from 'react-router';

export function combinedHandleElements<TProps>(
  // oxlint-disable-next-line typescript/no-explicit-any
  _matches: unknown[],
) {
  const matches = _matches as UIMatch[];
  const combinedProps: Record<string, unknown> = {};

  for (const match of matches) {
    if (match.handle) Object.assign(combinedProps, match.handle);
  }

  return combinedProps as TProps;
}
